export enum PatientDemographicsConstants {
  NOT_IMPLEMENTED = 'patientDemographics/NOT_IMPLEMENTED',
  SET_PATIENT_ID = 'patientDemographics/SET_PATIENT_ID',
  SET_PATIENT_RUN_ID = 'patientDemographics/SET_PATIENT_RUN_ID',
  SET_TEXAS_WRISTBAND = 'patientDemographics/SET_TEXAS_WRISTBAND',
  SET_FIRST_NAME = 'patientDemographics/SET_FIRST_NAME',
  SET_FIRST_NAME_PNNV = 'patientDemographics/SET_FIRST_NAME_PNNV',
  SET_MIDDLE_INITIAL = 'patientDemographics/SET_MIDDLE_INITIAL',
  SET_LAST_NAME = 'patientDemographics/SET_LAST_NAME',
  SET_LAST_NAME_PNNV = 'patientDemographics/SET_LAST_NAME_PNNV',
  SET_SUFFIX = 'patientDemographics/SET_SUFFIX',
  SET_TRIAGE_COLOR = 'patientDemographics/SET_TRIAGE_COLOR',
  SET_TRIAGE_COLOR_PNNV = 'patientDemographics/SET_TRIAGE_COLOR_PNNV',
  SET_DOB = 'patientDemographics/SET_DOB',
  SET_DOB_PNNV = 'patientDemographics/SET_DOB_PNNV',
  SET_AGE = 'patientDemographics/SET_AGE',
  SET_AGE_PNNV = 'patientDemographics/SET_AGE_PNNV',
  SET_AGE_UNIT = 'patientDemographics/SET_AGE_UNIT',
  SET_SSN = 'patientDemographics/SET_SSN',
  SET_SSN_PNNV = 'patientDemographics/SET_SSN_PNNV',
  SET_WEIGHT = 'patientDemographics/SET_WEIGHT',
  SET_WEIGHT_PNNV = 'patientDemographics/SET_WEIGHT_PNNV',
  SET_HEIGHT = 'patientDemographics/SET_HEIGHT',
  SET_SEX = 'patientDemographics/SET_SEX',
  SET_SEX_PNNV = 'patientDemographics/SET_SEX_PNNV',
  SET_GENDER = 'patientDemographics/SET_GENDER',
  SET_GENDER_PNNV = 'patientDemographics/SET_GENDER_PNNV',
  SET_BLOOD_TYPE = 'patientDemographics/SET_BLOOD_TYPE',
  SET_RACE = 'patientDemographics/SET_RACE',
  SET_RACE_PNNV = 'patientDemographics/SET_RACE_PNNV',
  SET_DRIVERS_LICENSE_NUMBER = 'patientDemographics/SET_DRIVERS_LICENSE_NUMBER',
  SET_DL_STATE = 'patientDemographics/SET_DL_STATE',
  SET_DNR = 'patientDemographics/SET_DNR',
  SAVE_PATIENT_DEMOGRAPHICS = 'patientDemographics/SAVE_PATIENT_DEMOGRAPHICS',
  SET_HEIGHT_UNITS = 'patientDemographics/SET_HEIGHT_UNITS',
  SET_WEIGHT_UNITS = 'patientDemographics/SET_WEIGHT_UNITS',
  SET_RUN_ID = 'patientDemographics/SET_RUN_ID',
  SET_ADDRESS_1 = 'patientDemographics/SET_ADDRESS_1',
  SET_ADDRESS_2 = 'patientDemographics/SET_ADDRESS_2',
  SET_ADDRESS_PNNV = 'patientDemographics/SET_ADDRESS_PNNV',
  SET_ZIP_CODE = 'patientDemographics/SET_ZIP_CODE',
  SET_CITY = 'patientDemographics/SET_CITY',
  SET_CITY_PNNV = 'patientDemographics/SET_CITY_PNNV',
  SET_STATE = 'patientDemographics/SET_STATE',
  SET_COUNTY = 'patientDemographics/SET_COUNTY',
  SET_COUNTRY = 'patientDemographics/SET_COUNTRY',
  SET_RESIDENT = 'patientDemographics/SET_RESIDENT',
  SET_ALT_HOME_RESIDENCE = 'patientDemographics/SET_ALT_HOME_RESIDENCE',
  SET_ALT_HOME_RESIDENCE_PNNV = 'patientDemographics/SET_ALT_HOME_RESIDENCE_PNNV',
  SET_CITIZENSHIP = 'patientDemographics/SET_CITIZENSHIP',
  SET_RESPONSE = 'patientDemographics/SET_RESPONSE',
  RESET_STATE = 'patientDemographics/RESET_STATE',
  SET_PATIENT_DEMOGRAPHICS = 'patientDemographics/SET_PATIENT_DEMOGRAPHICS',
  SET_DEMOGRAPHICS_GPS_N = 'patientDemographics/SET_DEMOGRAPHICS_GPS_N',
  SET_DEMOGRAPHICS_GPS_E = 'patientDemographics/SET_DEMOGRAPHICS_GPS_E',
  SET_PHONE_DETAILS = 'patientDemographics/SET_PHONE_DETAILS',
  SET_PHONE_DETAILS_PNNV = 'patientDemographics/SET_PHONE_DETAILS_PNNV',
  SET_PHONE_DETAILS_PNNV_TOGGLE = 'patientDemographics/SET_PHONE_DETAILS_PNNV_TOGGLE',
  SET_EMAIL_DETAILS = 'patientDemographics/SET_EMAIL_DETAILS',
  ADD_PHONE = 'patientDemographics/ADD_PHONE',
  ADD_EMAIL = 'patientDemographics/ADD_EMAIL',
  ADD_PHYSICIAN_LIST = 'patientDemographics/ADD_PHYSICIAN_LIST',
  SET_PHYSICIAN_DATA = 'patientDemographics/SET_PHYSICIAN_DATA',
  ADD_PHYSICIAN_DATA = 'patientDemographics/ADD_PHYSICIAN_DATA',
  SET_PHYSICIAN_FIRSTNAME = 'patientDemographics/SET_PHYSICIAN_FIRSTNAME',
  SET_PHYSICIAN_LASTNAME = 'patientDemographics/SET_PHYSICIAN_LASTNAME',
  SET_PHYSICIAN_MIDDLENAME = 'patientDemographics/SET_PHYSICIAN_MIDDLENAME',
  SET_PHYSICIAN_TYPE = 'patientDemographics/SET_PHYSICIAN_TYPE',
  CLEAR_PHYSICIAN_DATA = 'patientDemographics/CLEAR_PHYSICIAN_DATA',
  SET_BARRIERS_TO_CARE = 'patientDemographics/SET_BARRIERS_TO_CARE',
  SET_BARRIERS_TO_CARE_PNNV = 'patientDemographics/SET_BARRIERS_TO_CARE_PNNV',
  SET_PREFERRED_LANGUAGE = 'patientDemographics/SET_PREFERRED_LANGUAGE',
  RESET_EMPLOYER = 'patientDemographics/RESET_EMPLOYER',
  GET_PATIENT_COUNTY_OPTIONS = 'patientDemographics/GET_PATIENT_COUNTY_OPTIONS',
  REFRESH_PATIENT_DEMOGRAPHICS = 'patientDemographics/REFRESH_PATIENT_DEMOGRAPHICS',
  SET_PATIENT_DEMOGRAPHICS_DEFAULTS = 'patientDemographics/SET_PATIENT_DEMOGRAPHICS_DEFAULTS',
}
